export const projects = [
  {
    id: 1,
    slug: 'james-heidema-ai',
    name: 'James Heidema AI',
    shortDescription: 'AI-powered sales coaching platform with voice conversations and progress tracking',
    fullDescription: {
      problem: 'Sales coaches struggle to scale personalized training and support for their clients.',
      solution: 'Designed and built an AI-driven coaching platform delivering lifelike voice conversations, progress tracking, and session transcripts.',
      result: 'A scalable digital coaching experience that allows clients to practice sales conversations anytime.',
    },
    category: 'Web Apps',
    tags: ['AI', 'React', 'Voice Technology', 'Subscription Model', 'Admin Dashboard'],
    image: 'https://static.readdy.ai/image/0b415033dc3c77175cdee172dc914215/b935efcdd084a2ab1da12b74bc5be56b.png',
    imageAlt: 'James Heidema AI coaching platform with voice interface and transcription',
    url: 'https://jamesheidema-ai.com/',
    year: '2025',
    client: 'James Heidema',
    duration: '3 months',
    services: ['Web Development', 'AI Integration', 'Payment System', 'Admin Panel'],
    challenge: 'Create an AI coaching platform that feels as natural as talking to a real person, with the ability to interrupt and ask follow‑up questions in real‑time. The system needed to handle subscriptions, gifting, and provide comprehensive admin tools for managing users and sessions.',
    solution: 'Built a React‑based platform integrated with advanced AI voice technology that enables natural, interruption‑capable conversations. Implemented a robust subscription system with Stripe, session transcription and replay features, progress tracking dashboards, and a full admin panel for user and content management.',
    results: [
      'Natural voice interactions',
      'Real‑time transcription',
      'Subscription management',
      'Admin dashboard'
    ]
  },
  {
    id: 2,
    slug: 'verslodi-lt',
    name: 'Verslodi.lt',
    shortDescription: 'High-converting AI consulting landing page with calendar booking',
    fullDescription: {
      problem: 'AI consultants often struggle to clearly communicate their value and convert visitors into qualified leads.',
      solution: 'Created a strategic landing page with clear positioning, automated scheduling, and pre-call lead qualification.',
      result: 'A streamlined system that filters serious prospects and prepares them before consultations.',
    },
    category: 'Landing Pages',
    tags: ['Landing Page', 'AI Consulting', 'Calendar Integration', 'Lead Qualification', 'Conversion Optimization'],
    image: 'https://static.readdy.ai/image/0b415033dc3c77175cdee172dc914215/375b9f3d12d1183cbed9507576227a14.png',
    imageAlt: 'Verslodi.lt AI consulting landing page with calendar booking',
    url: 'https://www.verslodi.lt/',
    year: '2025',
    client: 'Verslodi',
    duration: '2 weeks',
    services: ['Landing Page Design', 'Calendar Integration', 'Lead Qualification', 'SEO'],
    challenge: 'Design a landing page that effectively communicates complex AI consulting services while capturing qualified leads. The page needed to integrate with a calendar system and include a questionnaire to filter and prepare prospects before consultations.',
    solution: 'Created a clean, conversion‑focused landing page with clear value propositions and trust signals. Integrated a self‑serve calendar booking system synced with real availability, and implemented a pre‑call questionnaire that qualifies leads and gathers essential information for productive consultations.',
    results: [
      'High conversion rate',
      'Automated booking',
      'Qualified leads only',
      'Time‑saving questionnaire'
    ]
  },
  {
    id: 3,
    slug: 'ubukire',
    name: 'Ubukire',
    shortDescription: 'Bilingual digital book store with instant delivery and gifting',
    fullDescription: {
      problem: 'Selling digital products globally requires secure payments, automated delivery, and scalable distribution.',
      solution: 'Designed a bilingual landing page with secure Stripe payments, instant email delivery, and automated follow-ups.',
      result: 'A frictionless digital product system capable of selling worldwide.',
    },
    category: 'Landing Pages',
    tags: ['Landing Page', 'E-commerce', 'Stripe', 'Multi-language', 'Digital Products'],
    image: 'https://static.readdy.ai/image/0b415033dc3c77175cdee172dc914215/b4c9542b52c5d41663b46dee4b89bb39.png',
    imageAlt: 'Ubukire bilingual digital book store with Stripe payments',
    url: 'https://ubukire.com/en',
    year: '2025',
    client: 'Ubukire',
    duration: '3 weeks',
    services: ['Landing Page Design', 'Payment Integration', 'Email Automation', 'Multi-language'],
    challenge: 'Build a bilingual platform for selling a digital book with secure payments, instant delivery, and gifting capabilities. Each copy needed personalized licensing and watermarking to prevent unauthorized sharing while maintaining a smooth user experience.',
    solution: 'Developed a bilingual landing page with Stripe payment integration for secure transactions. Implemented automated email delivery with personalized PDF watermarking for each buyer or gift recipient. Added gifting functionality and automated follow‑up email sequences to enhance customer engagement.',
    results: [
      'Instant delivery system',
      'Personalized watermarking',
      'Gift functionality',
      'Automated follow‑ups'
    ]
  },
  {
    id: 4,
    slug: 'siltos-zvakes',
    name: 'Šiltos Žvakės',
    shortDescription: 'Full-featured e-commerce store for handmade candles',
    fullDescription: {
      problem: 'Handmade brands often lack scalable online systems to present products and manage orders efficiently.',
      solution: 'Built a complete e-commerce platform with custom bundle creation, payments, and order management.',
      result: 'A streamlined online store designed to support growth and higher sales.',
    },
    category: 'E-commerce',
    tags: ['E-commerce', 'Payments', 'Gift Builder'],
    image: 'https://static.readdy.ai/image/0b415033dc3c77175cdee172dc914215/ceffe0d88d9ed8e6ce169ab84ef6f7f2.png',
    imageAlt: 'Šiltos Žvakės handmade candle e-commerce store with gift builder',
    url: 'https://siltoszvakes.lt/',
    year: '2025',
    client: 'Šiltos Žvakės',
    duration: '2 months',
    services: ['E-commerce Development', 'Payment System', 'Order Management', 'Custom Features'],
    challenge: 'Create a complete e-commerce solution for a handmade candle business that showcases products beautifully while providing a unique gift set builder feature. The system needed full cart functionality, payment processing, and order tracking capabilities.',
    solution: 'Built a full-featured e-commerce platform with an intuitive shopping cart, secure payment integration, and comprehensive order tracking. Developed a custom gift set builder that allows customers to create personalized bundles by selecting from the entire candle collection, enhancing the gifting experience.',
    results: [
      'Complete e-commerce system',
      'Custom gift builder',
      'Order tracking',
      'Increased sales'
    ]
  }
];